import { ValueTrimmer } from './utility/value-trimmer.directive';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { DatepickerModule, BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { UiSwitchModule } from 'ngx-toggle-switch';
import { ModalModule } from 'ngx-bootstrap';

import {
  MatButtonModule, MatDialogModule, MatTabsModule, MatIconModule, MatInputModule, MatPaginatorModule, MatSortModule, MatMenuModule,
  MatTableModule, MatSelectModule, MatToolbarModule, MatRadioModule, MatDatepickerModule,
  MatNativeDateModule, MatCardModule, MatCheckboxModule,MatSlideToggleModule,MatExpansionModule,MatTooltipModule,
  MatAutocompleteModule

} from '@angular/material';
import { ToastrModule } from 'ngx-toastr';
import { ClipboardModule } from 'ngx-clipboard';
import { NgxEditorModule } from 'ngx-editor';
import { LoginComponent } from './auth/login/login.component';
import { AuthGuard } from './auth/auth.guard';
import { NavBarComponent } from './nav-bar/nav-bar.component';
import { SideNavBarComponent } from './Navbar/side-nav-bar/side-nav-bar.component';
import { JwtModule } from '@auth0/angular-jwt';
// import { HomeComponent } from './home/home/home.component';
import { PageNotfoundComponent } from './Page-notfound/page-notfound/page-notfound.component';
import { authInterceptor } from './services/auth-interceptor';
import { TokenExpireComponent } from './Page-notfound/token-expire/token-expire.component';
import { AccessDeniedComponent } from './Page-notfound/access-denied/access-denied.component';
import { RolesComponent } from './access-control/roles/roles.component';
import { UserComponent } from './access-control/user/user.component';
import { UserListingComponent } from './access-control/user-listing/user-listing.component';
import { SystemModulesComponent } from './access-control/system-modules/system-modules.component';
import { RoleListingComponent } from './access-control/role-listing/role-listing.component';
import { PermissionsComponent } from './access-control/permissions/permissions.component';
import { AddSystemModuleComponent } from './access-control/add-system-module/add-system-module.component';
import { AddSectionComponent } from './access-control/add-section/add-section.component';
import { AddSectionActionComponent } from './access-control/add-section/add-section-action/add-section-action.component';
import { AddApplicationComponent } from './access-control/add-application/add-application.component';
import { ApplicationListingComponent } from './access-control/application-listing/application-listing.component';
import { SystemUserListingComponent } from './auth/system-users/system-user-listing/system-user-listing.component';
import { AddSystemUserComponent } from './auth/system-users/add-system-user/add-system-user.component';
import { ChangePasswordComponent } from './access-control/change-password/change-password.component';
import { ChangeUserStatusComponent } from './access-control/change-user-status/change-user-status.component';
import { ChangeSystemUserStatusComponent } from './auth/system-users/change-system-user-status/change-system-user-status.component';
import { PasswordMatcherDirective } from './utility/password-matcher.directive';
// import { PermissionsAuditComponent } from './access-control/permissions-audit/permissions-audit.component';
// import { RolesAuditComponent } from './access-control/roles-audit/roles-audit.component';
import { AppUserListingComponent } from './access-control/app-user-listing/app-user-listing.component';
import { AddAppUserComponent } from './access-control/add-app-user/add-app-user.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { UserDashboardComponent } from './access-control/user-setting/user-dashboard/user-dashboard.component';
import { PasswordProtectionPolicyComponent } from './access-control/password-protection-policy/password-protection-policy.component';
import { Ng5SliderModule } from 'ng5-slider';
import { NgxBootstrapSliderModule } from 'ngx-bootstrap-slider';
import { CertificatesComponent } from './certificates/certificates.component';
import { AssignUserComponent } from './access-control/assign-user/assign-user.component';
import { SectionListingComponent } from './access-control/section-listing/section-listing.component';
import { SignupComponent } from './auth/signup/signup.component';
import { FooterComponent } from './footer/footer.component';
import { AddCertificateComponent } from './add-certificate/add-certificate.component';
import { EmailtemplateComponent } from './notification-manager/emailtemplate/emailtemplate.component';
import { AddtemplateComponent } from './notification-manager/addtemplate/addtemplate.component';
import { DashboardComponent } from './dashboard/dashboard/dashboard.component';
import { SectionActionListingComponent } from './access-control/section-action-listing/section-action-listing.component';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { AgGridModule } from 'ag-grid-angular';
import { PreferencesComponent } from './preferences/preferences.component';
import { SupportedIdentityProvidersComponent } from './idp/supported-identity-providers/supported-identity-providers.component';
import { AppIdpComponent } from './aplication-idps/app-idp/app-idp.component';
import { ConsumerChangePasswordComponent } from './consumer-change-password/consumer-change-password.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { EditUserProfileComponent } from './edit-user-profile/edit-user-profile.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import {MinValue } from './utility/min-value.directive';
import {MaxPasswordAgeValidtor} from './utility/max-password-age-validator.directive';
import {MinPasswordAgeValidtor} from './utility/min-password-age-validator.directive';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ClientListingComponent } from './client/client-listing/client-listing.component';
import { AddClientComponent } from './client/add-client/add-client.component';
import { ClientApplicationListComponent } from './client/client-application-list/client-application-list.component';
import { IsValidEmail } from './utility/email-validator.directive';
import { OrganizationDashboardComponent } from './organization-dashboard/organization-dashboard.component';
import { ApplicationConfigurationComponent } from './client/application-configuration/application-configuration.component';
import {MaxValue} from './utility/max-value.directive';
import { SafeHtml } from './utility/safe-html.pipe';
import { EmailProvidersComponent } from './notification-manager/email-providers/email-providers.component';
import { MultifactorAuthComponent } from './auth/multifactor-auth/multifactor-auth.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {PopoverModule} from 'ngx-smart-popover';
import { ChangeForgetPasswordComponent } from './change-forget-password/change-forget-password.component';
import { ClientDetailsComponent } from './client/client-details/client-details.component';
import { BatchJobsComponent } from './batch-jobs/batch-jobs.component';
export function tokenGetter() {
  return localStorage.getItem('token');
}
import { MatTableExporterModule } from 'mat-table-exporter';
import { CustomFieldComponent } from './access-control/custom-field/custom-field.component';
import { WebHooksComponent } from './web-hooks/web-hooks.component';
import { ModulePermissionComponent } from './access-control/module-permission/module-permission.component';
import { TooltipDirective } from './utility/tooltip.directive';
import { SmsUsageComponent } from './access-control/sms-usage/sms-usage.component';
import { EmailVerificationComponent } from './access-control/email-verification/email-verification.component';
import { AddLinksComponent } from './access-control/add-links/add-links.component';
import { environment } from 'src/environments/environment';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { UserLogsComponent } from './user-logs/user-logs.component';
import { DeleteUserComponent } from './delete-user/delete-user.component';
import { LogicalAccessComponent } from './client/logical-access/logical-access.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    NavBarComponent,
    SideNavBarComponent,
    // HomeComponent,
    PageNotfoundComponent,
    TokenExpireComponent,
    RolesComponent,
    UserComponent,
    UserListingComponent,
    SystemModulesComponent,
    RoleListingComponent,
    PermissionsComponent,
    AddSystemModuleComponent,
    AddSectionComponent,
    AddSectionActionComponent,
    AccessDeniedComponent,
    AddApplicationComponent,
    ApplicationListingComponent,
    SystemUserListingComponent,
    AddSystemUserComponent,
    PasswordMatcherDirective,
    ChangePasswordComponent,
    ChangeUserStatusComponent,
    ChangeSystemUserStatusComponent,
    // PermissionsAuditComponent,
    // RolesAuditComponent,
    AppUserListingComponent,
    AddAppUserComponent,
    UserDashboardComponent,
    PasswordProtectionPolicyComponent,
    CertificatesComponent,
    AssignUserComponent,
    SectionListingComponent,
    SignupComponent,
    FooterComponent,
    AddCertificateComponent,
    EmailtemplateComponent,
    AddtemplateComponent,
    DashboardComponent,
    SectionActionListingComponent,
    PreferencesComponent,
    SupportedIdentityProvidersComponent,
    AppIdpComponent,
    ConsumerChangePasswordComponent,
    ForgetPasswordComponent ,
    EditUserProfileComponent,
    UserProfileComponent,
    MinValue,
    MinPasswordAgeValidtor,
    MaxPasswordAgeValidtor,
    ClientListingComponent,
    AddClientComponent,
    ClientApplicationListComponent,
    IsValidEmail,
    ValueTrimmer,
    OrganizationDashboardComponent,
    ApplicationConfigurationComponent,
    MaxValue,
    SafeHtml,
    EmailProvidersComponent,
    MultifactorAuthComponent,
    ChangeForgetPasswordComponent,
    ClientDetailsComponent,
    BatchJobsComponent,
    CustomFieldComponent,
    WebHooksComponent,
    ModulePermissionComponent,
    TooltipDirective,
    SmsUsageComponent,
    EmailVerificationComponent,
    AddLinksComponent,
    UserLogsComponent,
    DeleteUserComponent,
    LogicalAccessComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    MatPaginatorModule,
    MatSortModule,
    MatMenuModule,
    MatTableModule,
    MatSelectModule,
    MatToolbarModule,
    MatDatepickerModule,
    MatCardModule,
    MatRadioModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      // "positionClass": "toast-top-center"
    }),
    ModalModule.forRoot(),
    MatNativeDateModule,
    MatTabsModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter,
        //  whitelistedDomains: ['localhost:4000'],
        // blacklistedRoutes: ['localhost:4000/auth/login']
      },
    }),
    BsDatepickerModule.forRoot(),
    DatepickerModule.forRoot(),
    UiSwitchModule,
    NgMultiSelectDropDownModule.forRoot(),
    ClipboardModule,
    Ng5SliderModule,
    NgxEditorModule,
    NgxBootstrapSliderModule,
    MatExpansionModule,
    MatCheckboxModule ,
    NgxDropzoneModule,
    TooltipModule.forRoot(),
    MatProgressSpinnerModule,
    PopoverModule,
    MatTableExporterModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MatAutocompleteModule,
    MatTooltipModule,
    RecaptchaV3Module
  ],
  providers: [MatDatepickerModule, AuthGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: authInterceptor,
      multi: true
    },
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.recaptcha.siteKey,
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
